module.exports = __webpack_public_path__ + "img/ic-rename.98d8bac5.svg";